import * as React from 'react';

var _circle, _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgTusd = function SvgTusd(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#2B2E7F"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M64.126 71.135V49.128h2.983c9.323 0 11.934-8.951 11.934-8.951H54.057c-11.934 0-13.798 8.952-13.798 8.952h14.544v33.196c-.373 0 9.323-2.984 9.323-11.19"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M91.35 88.293c8.204-8.58 11.56-20.888 8.577-32.45-1.492-5.968-4.848-11.563-9.323-16.04l-1.12-1.118-.372-.373c-.373-.373-.746-.373-.746-.746l-.373-.373-.746-.746H86.13c-.373-.373-.746-.373-1.12-.746l-.745-.373c-.373 0-.373-.373-.746-.373l-.746-.373c.373-.373 0-.746-.373-.746l-.746-.373c-.373 0-.373-.373-.745-.373h-.373c1.118.746 1.864 1.12 2.61 1.865 12.68 12.682 13.052 33.196.373 46.25l-.373.374c-16.408 16.411-42.886 16.411-59.295 0l-1.864-1.865-.373-.373-1.119-1.12c2.238 4.104 4.848 7.834 8.204 11.19 17.155 16.785 44.751 16.785 61.906 0 .373-.745.373-.745.745-1.118"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M39.14 83.817c-.745-.746-1.491-1.12-2.237-1.865C24.223 69.27 23.85 48.382 36.53 35.7l.373-.373c16.409-16.412 42.886-16.412 59.295 0 1.118 1.119 2.237 2.238 3.356 3.73-2.238-4.103-4.848-7.833-8.204-11.19a43.66 43.66 0 0 0-61.906 0l-.745.746C17.51 40.55 15.646 58.08 24.969 71.508c3.357 5.222 8.578 9.698 14.171 12.309"
    })));
};

export { SvgTusd as ReactComponent };
//# sourceMappingURL=TUSD.svg.es.js.map
